<template>
    <div>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <v-btn
                    class="wishlist-button"
                    :class="buttonClass"
                    :color="isFavorite ? (buttonActiveColor || buttonColor) : buttonColor"
                    flat
                    icon
                    v-on="on"
                    @click="toggleWishlist"
                    v-show="displayButton"
                    :small="smallButton"
                >
                    <v-icon
                        :size="iconSize"
                        v-text="isFavorite ? activeIcon : icon"
                    />
                </v-btn>
            </template>

            <span v-html="tooltip" />
        </v-tooltip>
    </div>
</template>

<script>
    import { mapState, mapGetters, mapMutations } from 'vuex';

    export default {
        name: 'WishlistButton',
        data() {
            return {
                isTouchDevice: 'ontouchstart' in document.documentElement,
            };
        },
        props: {
            productId: {},
            showButton: {},
            showText: {},
            isNotAbsolute: {},
            disableTooltip: {},
            buttonAsLink: {},
            buttonColor: {},
            buttonActiveColor: {},
            smallButton: {},
            iconSize: {},
            icon: {
                type: String,
                default: 'favorite_border',
            },
            activeIcon: {
                type: String,
                default: 'favorite',
            },
            buttonClass: {},
        },
        computed: {
            ...mapState('Login', ['showLoginModal']),
            ...mapGetters('Login', ['isUserLoggedIn']),
            isFavorite() {
                return this.$wishlist.isFavorite(this.productId);
            },
            displayButton() {
                return this.showButton || this.isFavorite || this.isTouchDevice;
            },
            tooltip() {
                const message = this.isFavorite ? 'Von der Wunschliste entfernen' : 'Zur Wunschliste hinzufügen';
                return this.$language.translate(message);
            }
        },
        methods: {
            ...mapMutations('Login', ['setShowLoginModal']),
            toggleWishlist() {
                if (this.isUserLoggedIn) {
                    if (this.buttonAsLink) {
                        this.$router.push({
                            name: 'customer-wishlist',
                        });
                    } else {
                        this.$wishlist.toggleProduct(this.productId).then(result => {
                            if (result && result.success) {
                                if (result.action == 'add') {
                                    this.$emit('add', {
                                        productId: this.productId,
                                    });
                                } else if (result.action == 'remove') {
                                    this.$emit('remove', {
                                        productId: this.productId,
                                    });
                                }
                            }
                        });
                    }
                } else {
                    this.setShowLoginModal(true);
                }
            }
        },
        watch: {
            showLoginModal(newVal, oldVal) {
                if (newVal === false && oldVal === true) {
                    if (this.isUserLoggedIn) {
                        this.toggleWishlist();
                    }
                }
            }
        }
    };
</script>